import styled from 'styled-components'

export const QuickRequestGuidedIntakePromoStyled = styled.div`
  box-sizing: border-box;
  width: ${(props) => props.theme.typography.pxToRem(272)};
  padding: 0 ${(props) => props.theme.space.small}
    ${(props) => props.theme.space.small};
`
